import { usePortalAuthenticate } from './usePortalAuthenticate';
import { useAuthenticate } from './useAuthenticate';
import { RouteConfig } from './index';
import RouteWithPageTitle from './RouteWithPageTitle';
import ProtectedAccountRoute from './ProtectedAccountRoute';
import { PortalProvider } from './usePortalContext';

const ProtectedRoute = (props: RouteConfig) => {
  const {
    path,
    isRootOrAdminAccessible,
    accessibleRoles,
    accountRequired,
    element,
  } = props;

  // Check if running in iframe
  const isInIframe = window.self !== window.top;

  let portalAuth;
  let normalAuth;
  if (!isInIframe) {
    // Fallback to normal authentication if not in portal
    normalAuth = useAuthenticate();
  } else {
    // Try portal authentication first
    portalAuth = usePortalAuthenticate();
  }

  // Determine which authentication method to use
  const isAuthenticated = isInIframe
    ? portalAuth?.isAuthenticated && portalAuth.isReady
    : normalAuth;

  const isReady = isInIframe
    ? portalAuth?.isReady
    : true; // Normal auth is always ready when authenticated

  if (isAuthenticated && isReady) {
    const routeProps = {
      ...props,
      // Pass additional portal-specific props if needed
      ...(isInIframe && {
        readOnly: portalAuth?.readOnly,
        portalMode: true,
      }),
    };

    const portalContextValue = {
      isFromPortal: isInIframe,
      readOnly: portalAuth?.readOnly || false,
      accessToken: portalAuth?.accessToken || null,
    };

    const RouteComponent = accountRequired ? (
      <ProtectedAccountRoute
        key={path}
        element={element}
        isRootOrAdminAccessible={isRootOrAdminAccessible}
        accessibleRoles={accessibleRoles}
        {...routeProps}
      />
    ) : (
      <RouteWithPageTitle {...routeProps} />
    );

    return (
      <PortalProvider value={portalContextValue}>
        {RouteComponent}
      </PortalProvider>
    );
  }

  return (<></>);
};

export default ProtectedRoute;
